import { baseUrl, handleResponse, handleError, GetHeaders, postToOptionsApi, fetchFromOptionsApi } from "../common/ApiUtils";

const apiUrl = baseUrl + "Options/Employee";

export function getEmployeeStatement(employeeId) {
    return fetch(`${apiUrl}/${employeeId}/Statement`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function submitExerciseRequest(employeeId, exerciseRequests, notes, requestDate) {
    // Transform the request format to match the new ExerciseRequest API
    const createRequestDto = {
        employeeId: parseInt(employeeId),
        lineItems: exerciseRequests.map(req => ({
            optionAgreementId: req.optionAgreementId,
            cashlessShares: req.cashlessQuantity || 0,
            purchaseShares: req.purchaseQuantity || 0
        })),
        notes: notes || "Exercise request submitted from web application",
        requestDate: requestDate
    };

    // Submit exercise request (creates with submitted status)
    return postToOptionsApi('/api/ExerciseRequest/submit', createRequestDto);
}

export function approveExerciseRequest(exerciseRequestId, approvedBy) {
    return postToOptionsApi(`/api/ExerciseRequest/${exerciseRequestId}/approve`, {
        approvedBy: approvedBy
    });
}

export function getExerciseRequest(exerciseRequestId) {
    // Use the same API base as the create request
    return fetchFromOptionsApi(`api/ExerciseRequest/${exerciseRequestId}`);
}

export function getExerciseRequestsByEmployee(employeeId) {
    // Get all exercise requests for a specific employee (admin only)
    return fetchFromOptionsApi(`api/ExerciseRequest/employee/${employeeId}`);
}

export function getStockPrices() {
    // Get all stock prices for date-based price lookup
    return fetch(`${apiUrl}/StockPrices`, GetHeaders()).then(handleResponse).catch(handleError);
}